var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-alert", {
        attrs: {
          title:
            (_vm.sheetType === "svc"
              ? "储值卡会员"
              : _vm.sheetType === "platform"
              ? "平台用户"
              : "普通会员") +
            "当日总销量：" +
            (_vm.sheetType === "svc"
              ? _vm.numsFormat(_vm.daySumSvcNums)
              : _vm.sheetType === "platform"
              ? _vm.numsFormat(_vm.daySumPlatformNums)
              : _vm.numsFormat(_vm.daySumUserNums)) +
            "万升，占当日销量比例：" +
            (_vm.sheetType === "svc"
              ? _vm.percentFormat(_vm.daySumSvcNums, _vm.dayNums)
              : _vm.sheetType === "platform"
              ? _vm.percentFormat(_vm.daySumPlatformNums, _vm.dayNums)
              : _vm.percentFormat(_vm.daySumUserNums, _vm.dayNums)),
          type: "warning",
          description:
            (_vm.sheetType === "svc"
              ? "储值卡会员"
              : _vm.sheetType === "platform"
              ? "平台用户"
              : "普通会员") +
            "当月总销量：" +
            (_vm.sheetType === "svc"
              ? _vm.numsFormat(_vm.monthSumSvcNums)
              : _vm.sheetType === "platform"
              ? _vm.numsFormat(_vm.daySumPlatformNums)
              : _vm.numsFormat(_vm.monthSumUserNums)) +
            "万升，占当月销量比例：" +
            (_vm.sheetType === "svc"
              ? _vm.percentFormat(_vm.monthSumSvcNums, _vm.monthNums)
              : _vm.sheetType === "platform"
              ? _vm.percentFormat(_vm.daySumPlatformNums, _vm.dayNums)
              : _vm.percentFormat(_vm.monthSumUserNums, _vm.monthNums)),
          closable: false
        }
      }),
      _c(
        "el-radio-group",
        {
          staticStyle: { margin: "15px 0" },
          attrs: { size: "mini" },
          model: {
            value: _vm.selectedOilCode,
            callback: function($$v) {
              _vm.selectedOilCode = $$v
            },
            expression: "selectedOilCode"
          }
        },
        [
          _c(
            "el-radio",
            {
              attrs: { border: "", label: "92" },
              on: { change: _vm.selectedChange }
            },
            [_vm._v("92#汽油")]
          ),
          _c(
            "el-radio",
            {
              attrs: { border: "", label: "95" },
              on: { change: _vm.selectedChange }
            },
            [_vm._v("95#汽油")]
          ),
          _c(
            "el-radio",
            {
              attrs: { border: "", label: "0" },
              on: { change: _vm.selectedChange }
            },
            [_vm._v(" 0#柴油")]
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "tableStationDiscountSale" + _vm.sheetType,
          attrs: {
            data: _vm.renderData,
            "highlight-current-row": "",
            height: "660",
            "summary-method": _vm.getSummaries,
            "show-summary": "",
            "cell-style": _vm.cellStyle,
            "header-cell-style": { "text-align": "center" },
            border: ""
          },
          on: { "filter-change": _vm.filterChange }
        },
        [
          _c("el-table-column", {
            attrs: {
              fixed: "",
              label: _vm.selectedArea,
              align: "center",
              "column-key": "area",
              filters: _vm.filterMapping,
              "filter-multiple": false,
              "filter-placement": "right",
              "filter-method": _vm.filterHandler
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      " " + _vm._s(_vm.sellerName(scope.row.sellerId)) + " "
                    )
                  ]
                }
              }
            ])
          }),
          _c(
            "el-table-column",
            {
              attrs: {
                label:
                  _vm.selectedOilCode +
                  "# 日期：" +
                  _vm.timestamp2datestring(_vm.end / 1000, "YY年MM月DD日"),
                align: "center"
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "销量（L）",
                  align: "center",
                  prop:
                    _vm.sheetType === "user"
                      ? "daySumUserNums"
                      : _vm.sheetType === "platform"
                      ? "daySumPlatformNums"
                      : "daySumSvcNums"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "国家价（元/L）",
                  align: "center",
                  prop: "dayGoodsOriginal"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "油机价（元/L）",
                  align: "center",
                  prop:
                    _vm.sheetType === "user"
                      ? "dayUserGoodsPrice"
                      : _vm.sheetType === "platform"
                      ? "dayPlatformGoodsPrice"
                      : "daySvcGoodsPrice"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "均价（元/L）",
                  align: "center",
                  prop:
                    _vm.sheetType === "user"
                      ? "dayAvgUserPrice"
                      : _vm.sheetType === "platform"
                      ? "dayAvgPlatformPrice"
                      : "dayAvgSvcPrice"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "价差（元/L）",
                  align: "center",
                  prop:
                    _vm.sheetType === "user"
                      ? "dayDiffUserPrice"
                      : _vm.sheetType === "platform"
                      ? "dayDiffPlatformPrice"
                      : "dayDiffSvcPrice"
                }
              })
            ],
            1
          ),
          _c(
            "el-table-column",
            {
              attrs: {
                label:
                  _vm.selectedOilCode +
                  "# 月份：" +
                  _vm.timestamp2datestring(_vm.end / 1000, "YY年MM月"),
                align: "center"
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "销量（L）",
                  align: "center",
                  prop:
                    _vm.sheetType === "user"
                      ? "monthSumUserNums"
                      : _vm.sheetType === "platform"
                      ? "monthSumPlatformNums"
                      : "monthSumSvcNums"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "国家价（元/L）",
                  align: "center",
                  prop: "monthGoodsOriginal"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "油机价（元/L）",
                  align: "center",
                  prop:
                    _vm.sheetType === "user"
                      ? "monthUserGoodsPrice"
                      : _vm.sheetType === "platform"
                      ? "monthPlatformGoodsPrice"
                      : "monthSvcGoodsPrice"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "均价（元/L）",
                  align: "center",
                  prop:
                    _vm.sheetType === "user"
                      ? "monthAvgUserPrice"
                      : _vm.sheetType === "platform"
                      ? "monthAvgPlatformPrice"
                      : "monthAvgSvcPrice"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "价差（元/L）",
                  align: "center",
                  prop:
                    _vm.sheetType === "user"
                      ? "monthDiffUserPrice"
                      : _vm.sheetType === "platform"
                      ? "monthDiffPlatformPrice"
                      : "monthDiffSvcPrice"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }